import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import "./contact.css";

const Contact = () => {

  const form = useRef();
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You could add a toast notification here
  };

  const handleLinkClick = (e, url) => {
    e.preventDefault();
    if (url.startsWith('mailto:')) {
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('');

    // Log form data for debugging
    console.log('Sending email with form data:', {
      name: form.current.name.value,
      email: form.current.email.value,
      project: form.current.project.value
    });

    emailjs
      .sendForm('service_vjbik6l', 'template_naegcmo', form.current, {
        publicKey: 'HH_X26HGBlXv-ehYf',
      })
      .then(
        (result) => {
          console.log('Email sent successfully:', result.text);
          setStatus('SUCCESS');
          form.current.reset();
          setIsLoading(false);
          setTimeout(() => setStatus(''), 5000);
        },
        (error) => {
          console.error('Email send failed:', error.text);
          setStatus('FAILED');
          setIsLoading(false);
          setTimeout(() => setStatus(''), 5000);
        },
      );
  };
  return (
    <section className="contact section" id="contact">
      <h2 className="section_title">Hire Me</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact_container container grid">
        <div className="contact_content">
          <h3 className="contact_title">Talk to me</h3>

          <div className="contact_info">
            <div className="contact_card">
              <i className="bx bxl-mail-send contact_card-icon"></i>

              <h3 className="contact_card-title">Email</h3>
              <span className="contact_card-data">Okequadri23@gmail.com</span>

              <div className="contact_button-group">
                <button
                  onClick={() => copyToClipboard('Okequadri23@gmail.com')}
                  className="copy-button-centered"
                  title="Copy email"
                >
                  <i className="bx bx-copy"></i>
                </button>
                <a
                  href="mailto:Okequadri23@gmail.com"
                  className="contact_button"
                  onClick={(e) => handleLinkClick(e, 'mailto:Okequadri23@gmail.com')}
                >
                  Hire me
                  <i className="bx bx-right-arrow-alt contact_button-icon"></i>
                </a>
              </div>
            </div>

            <div className="contact_card">
              <i className="bx bxl-whatsapp contact_card-icon"></i>

              <h3 className="contact_card-title">Whatsapp</h3>
              <span className="contact_card-data">+234 70 449 669 50</span>

              <a
                href="https://wa.me/2347044966950?text=Hi%2C%20How%20can%20I%20be%20of%20service%20to%20you"
                className="contact_button"
                onClick={(e) => handleLinkClick(e, 'https://wa.me/2347044966950?text=Hi%2C%20How%20can%20I%20be%20of%20service%20to%20you')}
              >
                Hire me
                <i className="bx bx-right-arrow-alt contact_button-icon"></i>
              </a>
            </div>

            <div className="contact_card">
              <i className="bx bxl-twitter contact_card-icon"></i>

              <h3 className="contact_card-title">X account</h3>
              <span className="contact_card-data">@BigHarrr</span>

              <a
                href="https://twitter.com/messages/compose?recipient_id=1442214439554465793&text=Hi%2C%20How%20can%20I%20be%20of%20service%20to%20you"
                className="contact_button"
                onClick={(e) => handleLinkClick(e, 'https://twitter.com/messages/compose?recipient_id=1442214439554465793&text=Hi%2C%20How%20can%20I%20be%20of%20service%20to%20you')}
              >
                Hire me
                <i className="bx bx-right-arrow-alt contact_button-icon"></i>
              </a>
            </div>

            <div className="contact_card">
              <i className="bx bxl-linkedin contact_card-icon"></i>

              <h3 className="contact_card-title">LinkedIn</h3>
              <span className="contact_card-data">@Oke Quadri</span>

              <a
                href="https://www.linkedin.com/in/oke-quadri-3068b0243?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                className="contact_button"
                onClick={(e) => handleLinkClick(e, 'https://www.linkedin.com/in/oke-quadri-3068b0243?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app')}
              >
                Hire me
                <i className="bx bx-right-arrow-alt contact_button-icon"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="contact_content">
          <h3 className="contact_title">Bring your work</h3>

          <form ref={form} onSubmit={sendEmail} className="contact_form">
            <div className="contact_form-div">
              <label className="contact_form-tag">Name</label>
              <input type="text" name="name" className="contact_form-input" placeholder='insert your name ' required />
            </div>

            <div className="contact_form-div">
              <label className="contact_form-tag">Email</label>
              <input type="email" name="email" className="contact_form-input" placeholder='insert your Email ' required />
            </div>

            <div className="contact_form-div contact_form-area">
              <label className="contact_form-tag">Project</label>
              <textarea name="project" cols="30" rows="10" className="contact_form-input" placeholder='Describe your Project' required></textarea>
            </div>

            <button
              type="submit"
              className="button button--flex"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  Sending...
                  <i className="bx bx-loader-alt bx-spin"></i>
                </>
              ) : (
                <>
                  Send Dm
                  <svg
                    class="button__icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="var(--container-color)  "
                  >
                    <path
                      d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
                      fill="#000"
                    ></path>
                    <path
                      d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
                      fill="var(--container-color)"
                    ></path>
                  </svg>
                </>
              )}
            </button>

            {/* Status Notification */}
            {status && (
              <div className={`contact_status ${status === 'SUCCESS' ? 'success' : 'error'}`}>
                {status === 'SUCCESS' ? (
                  <div className="status_message">
                    <i className="bx bx-check-circle"></i>
                    Message sent successfully! I'll get back to you soon.
                  </div>
                ) : (
                  <div className="status_message">
                    <i className="bx bx-error-circle"></i>
                    Failed to send message. Please try again.
                  </div>
                )}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact